import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable()
export class LanguageDataProvider {
	constructor(public http: HttpClient) {}

	getLanguages() {
		const url = '/api/user/v1/company/language';
		return this.http.get(url);
	}

	updateLanguages(data) {
		const url = '/api/user/v1/company/language';
		return this.http.post(url, data);
	}

	getLabels() {
		const url = '/api/user/v1/company/language/label';
		return this.http.get(url);
	}

	updateLabels(url, data) {
		return this.http.post(url, data);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./shared/services/language/language.data.service.ts